import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  ApiVisa,
  BudgetFiscalYearPeriodService,
  Pagination,
  bl_fi_budget_fiscal_period_RowClass
} from "blg-akaun-ts-lib";
import { AppConfig } from "../../visa";
import { SubSink } from "subsink2";

@Component({
  selector: "app-select-budget-fiscal-period-gen-doc",
  templateUrl: "./select-budget-fiscal-period-gen-doc.component.html",
  styleUrls: ["./select-budget-fiscal-period-gen-doc.component.css"],
})
export class SelectBudgetFiscalPeriodGenDocComponent
  implements OnDestroy, OnChanges
{
  @Input() budgetFiscalPeriod = new FormControl();
  @Input() budgetVotebookGuid: string;
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  apiVisa: ApiVisa = AppConfig.apiVisa;

  allBudgetFiscalPeriods: bl_fi_budget_fiscal_period_RowClass[] = [];
  searchBudgetFiscalPeriods: bl_fi_budget_fiscal_period_RowClass[] = [];

  constructor(
    private budgetFiscalYearPeriodService: BudgetFiscalYearPeriodService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ("budgetVotebookGuid" in changes) {
      // React to changes in budgetVotebookGuid here
      const newGuid = this.budgetVotebookGuid;
      // Perform operations based on the new value
      if (newGuid !== null) {
        this.subs.sink = this.budgetFiscalYearPeriodService
          .getByCriteria(
            new Pagination(0, 10000, [
              {
                columnName: "votebook_guid",
                operator: "=",
                value: newGuid,
              },
            ]),
            this.apiVisa
          )
          .subscribe((response) => {
            let budgetFiscalPeriodListing: bl_fi_budget_fiscal_period_RowClass[] =
              [];
            response.data.forEach((data) => {
              data.bl_fi_budget_fiscal_period.map((fiscalPeriod) => {
                budgetFiscalPeriodListing.push(fiscalPeriod);
              });
            });
            this.allBudgetFiscalPeriods = budgetFiscalPeriodListing;
            this.searchBudgetFiscalPeriods = budgetFiscalPeriodListing;
          });
      }
    }
  }

  applyBudgetFiscalPeriodFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.searchBudgetFiscalPeriods = this.allBudgetFiscalPeriods.filter(
      (option) => option.fiscal_period_name.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
